var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcimaRightArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15147",
    "data-name": "Group 15147",
    transform: "translate(18449 22659)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4959",
    "data-name": "Rectangle 4959",
    width: 27,
    height: 23,
    rx: 4,
    transform: "translate(-18449 -22632) rotate(-90)",
    fill: "#0d6efd",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38121",
    "data-name": "Path 38121",
    d: "M12.013,8.416l-5.2-5.2-5.2,5.2L0,6.81,6.81,0l6.81,6.81Z",
    transform: "translate(-18432.986 -22652.355) rotate(90)",
    fill: "#0d6efd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcimaRightArrow);
export default __webpack_public_path__ + "static/media/acimaRightArrow.6980a142.svg";
export { ForwardRef as ReactComponent };